module.exports = __webpack_public_path__ + "static/media/8.e9e46fd8.png";